module.exports = require("obj2gltf");